import { apiClient } from '@/libs/apiClient';
import type {
  ApiJobDescriptionStatus as JobDescriptionsStatus,
  ApiJobPriority as JobDescriptionsPriority,
  ApiJobDescriptionSummary as GetJobDescriptionsResponseItem,
  JobDescriptionListQuery as GetJobDescriptionsParams,
  JobDescriptionListResponse as GetJobDescriptionsResponse,
} from '@/libs/api/jobDescriptionService';

export type {
  GetJobDescriptionsParams,
  GetJobDescriptionsResponse,
  GetJobDescriptionsResponseItem,
  JobDescriptionsPriority,
  JobDescriptionsStatus,
};

export const getJDs = (params: GetJobDescriptionsParams) =>
  apiClient.get<GetJobDescriptionsResponse>('/job-descriptions', { params });
